module.exports = __webpack_public_path__ + "img/newday.d11460e2.svg";